export default function SplitEventView ({
  backUrl,
  onConfirm,
  overlapInfo,
  splitPreview,
  isSubmitting
}) {
  // overlapInfo is now an array of all overlapping events
  if (!overlapInfo || !Array.isArray(overlapInfo) || overlapInfo.length === 0) return null

  const formatDate = (dateString) => {
    if (!dateString) return ''
    const date = new Date(dateString)
    return I18n.l('date.formats.long_date', date)
  }

  return (
    <div className='calendar-split-event'>
      <div className='mb-2'>
        {I18n.t('calendar.split_event.selected_time_period')}
      </div>
      {overlapInfo.map((overlap, index) => (
        <div key={index} className='mb-1'>
          <strong>
            {I18n.t('calendar.split_event.vacation')}: {formatDate(overlap.from)} - {formatDate(overlap.to)}
          </strong>
        </div>
      ))}

      <div className='mb-3 mt-2'>
        {I18n.t('calendar.split_event.want_convert_vacation')}
      </div>

      <div className='row mt-3'>
        <div className='col-md-4 mb-3'>
          <div className='pb-2'>{I18n.t('calendar.split_event.before')}:</div>
          {overlapInfo.map((overlap, index) => (
            <div key={index} className='mb-1'>
              {formatDate(overlap.from)} - {formatDate(overlap.to)}
              <span className='main_event_type'>
                {overlap.title || I18n.t('calendar.split_event.vacation')}
              </span>
            </div>
          ))}
        </div>

        <div className='col-md-4'>
          <div className='pb-2'>{I18n.t('calendar.split_event.after')}:</div>
          {splitPreview && splitPreview.map((period, index) => (
            <div key={index} className='mb-1'>
              {formatDate(period.start_date)} - {formatDate(period.end_date)}
              <span className={period.main_vacation ? 'main_event_type' : 'other_event_type'}>
                {period.title}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className='row mt-3'>
        <div className='col-md-4'>
          <a href={backUrl} className='btn btn-default btn-back w-100'>
            {I18n.t('back')}
          </a>
        </div>
        <div className='col-md-4'>
          <button
            type='button'
            className='btn btn-primary btn-save w-100'
            onClick={onConfirm}
            disabled={isSubmitting}
          >
            {isSubmitting ? I18n.t('loading') : I18n.t('save')}
          </button>
        </div>
      </div>
    </div>
  )
}
